import { Schema } from 'effect';

import { GtmItemsArraySchema } from './items';
import { Number } from '../primitive/number';
import { StringRequired } from '../primitive/string';

/**
 * Triggered when a user views an item
 * Based on: https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtm#view_item_details
 */
export const GtmViewItemEventSchema = Schema.Struct({
  event: Schema.Literal('track.view_item'),
  ecommerce: Schema.Struct({
    currency: StringRequired,
    value: Number,
    items: GtmItemsArraySchema,
  }),
}).annotate({ identifier: 'GtmViewItemEventSchema' });

export type GtmViewItemEvent = Schema.Schema.Type<typeof GtmViewItemEventSchema>;
